import { useQuerySubscription } from "react-datocms"
import { getSubscription, queries } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import BespokeTestimonials from "@components/layouts/bespoke/BespokeTestimonials/BespokeTestimonials"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

const TestimonialsPage = ({ options, subscription }) => {
  const {
    data: { seo, testimonialsPage },
  } = useQuerySubscription(subscription)
  return (
    <Layout options={options}>
      <Seo global={seo} title="HOPP Matchmaker" />
      <BespokeTestimonials title={testimonialsPage.title} testimonials={testimonialsPage.testimonials} />
    </Layout>
  )
}

export async function getStaticProps() {
  const graphqlRequest = {
    query: `
      {
        ${queries.seo}
        ${queries.testimonialsPage}
      }
    `,
  }

  const subscription = await getSubscription(graphqlRequest)

  const options = await loadOptionsData()

  return {
    props: {
      subscription,
      options,
    },
  }
}

export default TestimonialsPage
